import { StartEnd } from './start-end';

export class StartEndsList {
  startEnds: StartEnd[];

  constructor() {
    this.startEnds = [];
  }

  /*addCableNodes(start: string, end: string) {
    for (const se of this.startEnds) {
      if (se.start == start) {
        se.ends.push(end);
        break;
      }
    }
  }*/

  getStartEnd(start: string) {
    for (const se of this.startEnds) {
      if (se.start == start) {
        return se;
      }
    }
  }

}
